import { type JSX } from 'react';

import { type ChipProps } from '@mui/material/Chip';

import { AlertCalendarOutlined } from '@craft/ui/components/svgs';

import { StyledCalendarTodayOutlined } from '@/src/components/atoms/chips/DueDateChip/helpers/StyledCalendarTodayOutlined';

interface OverdueStatusStyling {
  chipColor?: ChipProps['color'];
  chipIcon: JSX.Element;
  chipSx: {
    border: string | undefined;
    borderColor: string | undefined;
    color?: string | undefined;
  };
  chipTestid: string;
}

/**
 * Function to determine styling for an overdue status chip based on the isOverdue parameter.
 *
 * @returns {OverdueStatusStyling} An object containing styling properties for the chip.
 */
export const getOverdueStatusStyling = (
  isPastDueDate: boolean,
  isUnsubmitted: boolean,
): OverdueStatusStyling => {
  const isOverdue = isPastDueDate && isUnsubmitted;

  if (isOverdue) {
    return {
      chipColor: 'error',
      chipIcon: <AlertCalendarOutlined />,
      chipSx: {
        border: undefined,
        borderColor: 'error.dark',
        color: 'error.dark',
      },
      chipTestid: 'overdue-chip',
    };
  }

  return {
    chipColor: undefined,
    chipIcon: <StyledCalendarTodayOutlined />,
    chipSx: {
      border: 'none',
      borderColor: undefined,
    },
    chipTestid: 'on-time-chip',
  };
};
